import makeMobileInput from "./shared/mobile-input";

const mobileInputSelectors = [
	// 'input[type="tel"]',
	'.woocommerce-checkout #billing_phone',
	'.woocommerce-checkout #shipping_phone',
	'.woocommerce-form #billing_phone',
	'.woocommerce-form #shipping_phone',
	'.woocommerce-address-fields #billing_phone',
	'.woocommerce-address-fields #shipping_phone',
	//more selectors to be added as discovered...
];

document.addEventListener('DOMContentLoaded', () => {
	const $inputs = document.querySelectorAll(mobileInputSelectors.join(','));

	if ($inputs.length === 0) {
		return;
	}

	$inputs.forEach($input => makeMobileInput($input));
});
